import { UserActionTypes } from '../actions/userActions';
import { userService } from '../../services/userService';

let user = userService.getUser();
const initialState = user
  ? { loggedIn: true, error: null, loggining: false, user }
  : { loggedIn: false, error: null, loggining: false };

export default function(state = initialState, { type, user, error, email }) {
  switch (type) {
    case UserActionTypes.LOGIN_REQUESTED:
    case UserActionTypes.SIGNUP_REQUESTED:
      return {
        loggining: true
      };
    case UserActionTypes.LOGIN_SUCCEEDED:
      return {
        loggedIn: true,
        user
      };
    case UserActionTypes.LOGIN_FAILED:
      return {
        loggedIn: false,
        error
      };
    case UserActionTypes.SIGNUP_SUCCEEDED:
      return {
        signup: true,
        email
      };
    case UserActionTypes.SIGNUP_FAILED:
      return {
        error
      };
    case UserActionTypes.RESET_PASSWORD_SUCCEEDED:
      return {
        success: true,
        email
      };
    case UserActionTypes.RESEND_ACTIVATION_FAILED:
      return {
        error
      };
    case UserActionTypes.RESEND_ACTIVATION_SUCCEEDED:
      return {
        success: true,
        email
      };
    case UserActionTypes.RESET_PASSWORD_FAILED:
      return {
        error
      };
    case UserActionTypes.UPDATE_PASSWORD_SUCCEEDED:
      return {
        success: true
      };
    case UserActionTypes.UPDATE_PASSWORD_FAILED:
      return {
        error
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/userReducer.js